import styled from 'styled-components';

export const ColumnSetPopupContainer = styled.div`
  background: #1f242c;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  & > div.title {
    background: #3a3a3a;
    padding: 0.2rem 1rem;
    margin-bottom: 1rem;
  }

  & > form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    & > div.btn-box {
      width: 100%;
      margin-top: 1rem;
    }
  }
`;
